import styled from 'styled-components';

export const RoleBox = styled.div`
  display: flex;
  > p {
    margin-right: 16px;
    text-decoration: underline;
    cursor: pointer;
  }
`;
